import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    layout: css({
        height: '100%',
        width: '100%',
        display: 'flex',
        padding: '50px',
        gap: '60px',
        justifyContent: 'center',
        alignItems: 'flex-start',
        [theme.breakpoints.down('lg')]: {
            padding: '20px',
        },
    }),

    agreementLayout: css({
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    }),

    icon: css({
        marginRight: '10px',
        '.arrow-color': {
            fill: isHosTheme ? theme.palette.text.primary : theme.palette.customBlue,
        },
    }),

    wrapBox: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '20px',
        alignSelf: 'stretch',
        paddingTop: '20px',
    }),

    backWrapper: css({
        display: 'flex',
        flexDirection: 'column',
        padding: '0 20px',
        textAlign: 'center',
        gap: '20px',
        alignItems: 'center',
        margin: '30px 0 40px 0',
        justifyContent: 'center',
        alignSelf: 'stretch',
        ...(isHosTheme && {
            [theme.breakpoints.up('lg')]: {
                textAlign: 'left',
                padding: '10px 0',
                display: 'inline',
            },
        }),
    }),

    back: css({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: isHosTheme ? '22px' : '60px',
        color: isHosTheme ? theme.palette.text.primary : theme.palette.customBlue,
        cursor: 'pointer',
        textDecoration: isHosTheme ? 'underline' : 'none',
        ':hover': {
            textDecoration: 'underline',
        },
        [theme.breakpoints.down('lg')]: {
            textDecoration: 'underline',
            margin: '0 auto',
        },
    }),

    leftSide: css({
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        [theme.breakpoints.up('lg')]: {
            maxWidth: '710px',
            gap: '40px',
        },
    }),

    rightSide: css({
        position: 'sticky',
        top: '60px',
        display: 'none',
        [theme.breakpoints.up('lg')]: {
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            width: '360px',
            minWidth: '360px',
        },
    }),

    paymentPlanWrapper: css({
        display: 'flex',
        flexDirection: 'column',
        ...(isHosTheme && { gap: '10px' }),
    }),

    overviewPayment: css({
        border: `1px solid ${theme.palette.grey[600]}`,
        padding: '7px 20px 20px 20px',

        ...(isHosTheme && {
            border: 'none',
            padding: '0px',
        }),
    }),

    cta: css({
        display: 'flex',
        height: '45px',
        padding: '16px 16px 12px 16px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '16px',
        borderRadius: '100px',
        paddingBlock: '16px',
        width: '100%',
        alignSelf: 'stretch',
        marginTop: '30px',
        textTransform: 'uppercase',
    }),

    extraPadding: css({
        padding: '20px 0',
    }),
};
